import type React from "react"
import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps } from "react-aria-components"
import { twMerge } from "tailwind-merge"

type SwitchProps = Omit<AriaSwitchProps, "children" | "className"> & {
  children?: React.ReactNode
  size?: "small" | "medium" | "large"
  className?: string
}

/**
 * A component that allows the user to toggle between two states. Great for settings or enabling/disabling features.
 *
 * ```tsx
 * import { Switch } from "@tokenterminal/core/ui/input/switch/Switch"
 *
 * <Switch>Enable</Switch>
 * ```
 */

export const Switch = ({ children, size = "medium", className, ...props }: SwitchProps) => {
  return (
    <AriaSwitch data-size={size} className={twMerge("tt-switch", className)} {...props}>
      <div className="tt-indicator" />
      {children}
    </AriaSwitch>
  )
}
